import useCallApi from '../../utilities/axios'
import {
    deleteChecklist as deleteChecklistUrl,
    getAllChecklist as checklistUrl,
    orderChecklist as orderChecklistUrl,
} from './umServiceURL'

export interface Checklist {
    checklistID: number
    nameTH: string
    nameEN: string
    children: SubChecklist[] | null
    answers: ChecklistAnswer[] | null
}

export type SubChecklist = Pick<Checklist, 'checklistID' | 'nameEN' | 'nameTH' | 'answers'>

export type ChecklistAnswer = Pick<Checklist, 'checklistID' | 'nameEN' | 'nameTH'> & { isDefault: boolean }

export interface ChecklistRequest {
    topicID: number
    irb: number
    parentID: number | null
    childrenID?: number | null
    nameTH: string
    nameEN: string
    isAnswer: boolean
    isDefault: boolean
    checklistID?: number | null
}

export interface DeleteChecklistRequest {
    checklistID: number
    parentID: number | null
    childrenID?: number | null
    isAnswer?: boolean
}

export type OrderChecklistRequest = Checklist[]

export default function useChecklist() {
    const callApi = useCallApi()

    async function getChecklistList(topicID: number, irb: number) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: Checklist[]
        }>({
            url: `${checklistUrl}/${topicID}/${irb}`,
        })

        return data
    }

    async function createChecklist(params: ChecklistRequest) {
        const { data } = await callApi.axiosPost<{
            message: string
            status: number
            result: string
        }>({
            url: checklistUrl,
            params,
        })

        return data
    }

    async function updateChecklist(topicID: number, params: ChecklistRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({
            url: `${checklistUrl}/${topicID}`,
            params,
        })

        return data
    }

    async function deleteChecklist(topicID: number, params: DeleteChecklistRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({
            url: `${deleteChecklistUrl}/${topicID}`,
            params,
        })

        return data
    }

    async function orderChecklist(topicID: number, params: OrderChecklistRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({
            url: `${orderChecklistUrl}/${topicID}`,
            params,
        })

        return data
    }

    return {
        getChecklistList,
        createChecklist,
        updateChecklist,
        deleteChecklist,
        orderChecklist,
    }
}
